export default "__VITE_ASSET__BsVFKE4D__"